import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import OperatingModesPage from '@/pages/OperatingModesPage';
import ModeScenariosPage from '@/pages/ModeScenariosPage';
import ModeMatrixPage from '@/pages/ModeMatrixPage';
import FlowMapPage from '@/pages/FlowMapPage';

export default function OperatingModelModule() {
  const tabs = [
    { id: 'modes', label: 'Modes', content: <OperatingModesPage /> },
    { id: 'flow-map', label: 'Flow Map', content: <FlowMapPage /> },
    { id: 'scenarios', label: 'Implementation', content: <ModeScenariosPage /> },
    { id: 'matrix', label: 'Matrix', content: <ModeMatrixPage /> },
  ];

  return (
    <ModuleShell
      title="Operating Model"
      subtitle="How the platform is deployed, what each mode controls, and every flow it runs"
      tabs={tabs}
    />
  );
}
